import Navbar from '../components/Navbar/Navbar';
import React, { useEffect, useState } from 'react';
import { GET_EXPENSE_BASE_URL, getFormData } from '../api/api';
import useStyles from "../steps/styles";
import { Box, Grid, Typography } from '@material-ui/core';
import { useParams } from "react-router-dom";
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import AdditionalExpensePaymentStep from './AdditionalExpensePaymentStep';
import { projectTitle } from '../constants/settings';
import { additionalExpenceValidationSchema } from './validationUtil';
import { yupResolver } from '@hookform/resolvers/yup';
import Loader from '../components/Loader/Loader';

const AdditionalExpenseForm = () => {
  const classes = useStyles();
  const { token } = useParams();

  const [activeStep, setActiveStep] = useState(0);
  const [apiData, setApiData] = useState({});


  useEffect(() => {
    let mounted = true;
    const url = `${GET_EXPENSE_BASE_URL}${token}`;
    getFormData(url).then((data) => {
      // console.log(data)
      if (mounted) {
        setApiData(data);
      }
    });
    return () => (mounted = false);
  }, []);

  return (
    <>
      <Navbar apiData={apiData} />
      <main className={classes.mainSection}>
        <Grid container>
          {typeof apiData === "object" && Object.keys(apiData).length > 1 ? (
            <FormWrap
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              classes={classes}
              apiData={apiData}
            />
          ) : (
            <Grid container>
              <Grid item xs={12} className={classes.mainForm}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  {typeof apiData === "string" ? (
                    <Typography variant="h2">{apiData}</Typography>
                  ) : (
                    <Loader />
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      </main>
    </>
  )
}


const FormWrap = ({
  setActiveStep,
  activeStep,
  classes,
  apiData,
}) => {

  const token =  window.location.pathname.split('/').slice(2, 3)[0]

  const defaultValues = {
    travelCare: "",
    cards: [],
    tips: 10,
    acceptTips: true,
    confirmTerms: false,
    splitPayment: apiData?.splitPayment ? apiData.splitPayment : apiData.cards?.length > 1,
    manualSplit: false,
    isForceManualSplit: false,
    cardsAmmount: [],
  };

  // ensure is date object for date picker validation
  defaultValues.cards = apiData.cards?.length ? apiData.cards.map( card => {
    card.expirationDate = new Date(card.expirationDate)
    return card
  }) : [{
    id: null,
    cardNumber: "",
    cardHolderName: "",
    expirationDate: null,
    cvv: "",
    country: "",
    city: "",
    state: "",
    street: "",
    postalCode: "",
    cardHolderEmail: "",
    cardPhoneNumber: "",
    billingAddress: "default",
  }]

  if (!!apiData.result) {
    Object.keys(apiData.result).forEach(field => {
      defaultValues[field] = apiData.result[field]
    })


  }

  //Validation handler
  const currentValidationSchema = additionalExpenceValidationSchema[activeStep];

  //Initialize form
  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(currentValidationSchema),
    mode: "onChange",
  });

  const { handleSubmit, trigger, control, setValue } = methods;


  const cards = useWatch({
    control,
    name: "cards",
  });

  const tipsValue = useWatch({
    control,
    name: "tips",
  });

  //Main form methods
  const onSubmit = (data) => {
    setActiveStep(1)


    data.cards = data.cards.map(card => {
      if (typeof card.expirationDate !== 'string') {
        card.expirationDate = card.expirationDate.toDateString()
      }
      return card
    })

    //
    data.token = token
    //
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
    //
    // console.log("data submit", data );
    fetch(`/api/productOfferStore/${token}`, requestOptions)
      .then(async res => {
        if (res.ok) {
          // TODO: ?
          // googleEvent.onSuccess()
          setActiveStep(2)
          return res.json()
        } else {
          alert(await res.text());
          setActiveStep(0)
          return res?.statusText;
        }
      }).catch(err => {
        alert("Sorry, something went wrong. Please try again");
          setActiveStep(0)
        return err;
      });
  };




  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <AdditionalExpensePaymentStep
            apiData={apiData}
            handleSubmit={handleSubmit(onSubmit)}
            cards={cards}
            tipsValue={tipsValue}
          />
        );

      case 1:
        return (
          <Box
            className={classes.thankYouPage}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography variant="h1" component="h1" gutterBottom>Loading, please wait...</Typography>
          </Box>
        );
      case 2:
        return (
          <Box
            className={classes.thankYouPage}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography variant="h1" component="h1" gutterBottom>Thank you for booking with {projectTitle}!</Typography>
          </Box>
        );

    }
  }


  return (
    <Grid container>
      <Grid item xs={12}>
        <FormProvider {...methods}>
          <form style={{ paddingBottom: "0px", height: "100%" }}>
            <Grid container className={classes.instructions}>
              <Grid item xs={12} style={{ height: "100%" }}>
                {getStepContent(activeStep)}
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </Grid>
    </Grid>
  );
}


export default AdditionalExpenseForm;
